import Information from './Information'
import Setting from './Setting'
import Statement from '../ContentDeliveryNetwork/Statement'
import Monitoring from './Monitoring'

const Recording = {
    Information,
    Setting,
    Statement,
    Monitoring,
}

export default Recording
